import { Injectable } from '@angular/core';
import { AbstractToolService } from './abstract-tool.service';
import { DesignHostContainer } from '../types';

@Injectable({
  providedIn: 'root'
})
export class MoveDownToolService extends AbstractToolService {
  constructor() {
    super();
  }

  do(host: DesignHostContainer, args: any) {
    // const index = host.parentHost.indexOf(host.componentRef.hostView);
    // host.parentHost.move(host.componentRef.hostView, index + 1);

    host.parentHost.moveDownView(host.componentRef.hostView);

    super.raiseCompletedEvent(args);
  }
}
